import { useQuery } from "@tanstack/react-query";

import type { CrmEnrichmentJobPriceDto } from "app/pages/sales-intelligence/modules/crm-enrichment/types/types";

import hubspotEnrichmentAPIService from "../services/api/hubspotEnrichmentAPIService";

import { hubspotEnrichmentQueryKeys } from "./queryKeyFactory";

const useHsEnrichmentJobPriceQuery = (fields: CrmEnrichmentJobPriceDto) => {
    return useQuery({
        enabled: fields.length > 0,
        queryKey: hubspotEnrichmentQueryKeys.estimatedPrice(fields),
        queryFn() {
            return hubspotEnrichmentAPIService.getEstimatedPrice(fields);
        },
    });
};

export default useHsEnrichmentJobPriceQuery;
